import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TermsOfService.css';

const TermsOfService = () => {
    const navigate = useNavigate();

    return (
        <div className="terms-container">
            <div className="terms-header">
                <h1>利用規約</h1>
            </div>
            <div className="terms-content">
                <section>
                    <h2>第1条（適用）</h2>
                    <p>
                        本利用規約（以下「本規約」）は、FlowText（以下「本サービス」）の利用条件を定めるものです。ユーザーは、本規約に同意の上、本サービスを利用するものとします。
                    </p>
                </section>

                <section>
                    <h2>第2条（利用資格）</h2>
                    <ul>
                        <li>13歳未満の方は本サービスを利用できません。</li>
                        <li>13歳以上18歳未満の方は、法定代理人の同意を得た上で利用してください。</li>
                        <li>ユーザーが本サービスを利用した場合、本条の条件を満たしていることを表明したものとみなします。</li>
                    </ul>
                </section>

                <section>
                    <h2>第3条（禁止事項）</h2>
                    <p>ユーザーは、以下の行為を行ってはなりません。</p>
                    <ul>
                        <li>法令または公序良俗に違反する行為</li>
                        <li>犯罪行為に関連する行為</li>
                        <li>暴力的、差別的、性的その他不適切な内容の生成・入力</li>
                        <li>個人情報や機密情報の入力</li>
                        <li>本サービスの運営を妨害する行為</li>
                        <li>不正アクセス、大量リクエスト等の濫用行為</li>
                        <li>その他、運営者が不適切と判断する行為</li>
                    </ul>
                </section>

                <section>
                    <h2>第4条（AIの特性）</h2>
                    <ul>
                        <li>本サービスはOpenAI社のAPIを利用しています。</li>
                        <li>AIの生成結果は正確性・完全性を保証するものではありません。</li>
                        <li>医療・法律・投資など専門的判断には使用しないでください。</li>
                        <li>生成結果の利用はユーザーの責任で行ってください。</li>
                        <li>本サービスはOpenAI社とは独立したサービスです。</li>
                    </ul>
                </section>

                <section>
                    <h2>第5条（利用停止）</h2>
                    <p>
                        運営者は、ユーザーが本規約に違反した場合、事前の通知なく利用制限またはアカウント停止を行うことができます。
                    </p>
                </section>

                <section>
                    <h2>第6条（免責事項）</h2>
                    <ul>
                        <li>本サービスは無料で提供されるものであり、現状有姿で提供されます。</li>
                        <li>本サービスの利用により生じた損害について、運営者は故意または重過失がある場合を除き、責任を負いません。</li>
                        <li>本サービスの変更、停止、終了によって生じた損害についても責任を負いません。</li>
                    </ul>
                </section>

                <section>
                    <h2>第7条（サービスの変更・終了）</h2>
                    <p>
                        運営者は、事前の通知なく、本サービスの内容を変更または終了することができます。
                    </p>
                </section>

                <section>
                    <h2>第8条（規約の変更）</h2>
                    <p>
                        運営者は、本規約を変更できるものとします。変更後に本サービスを利用した場合、変更後の規約に同意したものとみなします。
                    </p>
                </section>

                <div className="terms-actions">
                    <button onClick={() => navigate('/')} className="back-button">
                        トップページに戻る
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
